import React from 'react';

/**
 * file-type marker for a report row. every report is a pdf, so this is a constant
 * visual cue rather than something derived from the row.
 */
export default function PdfBadge() {
  return (
    <span
      aria-hidden
      className='inline-flex size-7 shrink-0 items-center justify-center rounded-md bg-semantic-danger text-[9px] font-bold text-white'
    >
      PDF
    </span>
  );
}
